import { useEffect, useState } from 'react';

interface BarcodeData {
  barcodeId: string;
  gdBarcodeIdExpiration: string;
}

interface UseBarcodeExpirationResult {
  isBarcodeExpired: boolean;
}

export const useBarcodeExpiration = (
  barcodeData: BarcodeData | null,
): UseBarcodeExpirationResult => {
  const [currentTime, setCurrentTime] = useState(() => Date.now());

  const expirationTime = barcodeData?.gdBarcodeIdExpiration
    ? new Date(barcodeData.gdBarcodeIdExpiration).getTime()
    : null;

  const isBarcodeExpired =
    expirationTime !== null && currentTime >= expirationTime;

  useEffect(() => {
    if (!expirationTime) {
      return;
    }
    const interval = setInterval(() => setCurrentTime(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [expirationTime]);

  return {
    isBarcodeExpired,
  };
};
